import { AxiosResponse } from 'axios';
import { IGetJobsRequestParams, IGetJobsResponse } from '../../interface';
import api from '../api';

const fetchJobs = async (
  params: IGetJobsRequestParams,
): Promise<AxiosResponse<IGetJobsResponse>> => {
  const res: AxiosResponse<IGetJobsResponse> = await api.get('/message-queue', { params });
  return res;
};

export const messageQueueService = {
  fetchJobs,
};
